import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { API } from '../config';
import AddressCascade from '../components/AddressCascade';

const COLS = [
  { k: 'fwa_5g', l: 'FWA 5G', t: 'ok' },
  { k: 'fwa_4g', l: 'FWA 4G', t: 'ok' },
  { k: 'fibra_10g', l: 'Fibra 10G', t: 'ok' },
  { k: 'fibra_nere', l: 'Fibra nere', t: 'ok' },
  { k: 'fibra_bianche', l: 'Fibra bianche', t: 'ok' },
  { k: 'xdsl_30m', l: 'xDSL 30M', t: 'speed' },
  { k: 'xdsl_fast200', l: 'xDSL Fast 200', t: 'speed' },
  { k: 'adsl_prof', l: 'ADSL Prof.', t: 'ok' },
  { k: 'ftto', l: 'FTTO', t: 'fascia' },
  { k: 'eth_silver', l: 'Eth. Silver', t: 'fascia' },
  { k: 'eth_gold', l: 'Eth. Gold', t: 'fascia' },
  { k: 'fibra_prof_10g', l: 'Fibra Prof. 10G', t: 'ok' },
  { k: 'fibra_prof', l: 'Fibra Prof.', t: 'ok' },
];

const Check = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
);

function valDisplay(col, val) {
  if (!val) return <span style={{ color: 'var(--muted)' }}>—</span>;
  if (col.t === 'ok') {
    if (val.esito === 'OK') return <Check />;
    if (val.esito === 'GIALLO') return <span style={{ color: '#f59e0b' }}>~</span>;
    return <span style={{ color: 'var(--muted)' }}>—</span>;
  }
  if (col.t === 'speed') {
    return (val.esito === 'OK' && (val.up || val.down))
      ? <span style={{ color: 'var(--ink)', fontWeight: 600 }}>{val.up || '?'}/{val.down || '?'}</span>
      : <span style={{ color: 'var(--muted)' }}>—</span>;
  }
  if (col.t === 'fascia') {
    return val.fascia
      ? <span style={{ color: 'var(--ink)', fontWeight: 600 }}>{val.fascia}</span>
      : (val.esito === 'OK' ? <Check /> : <span style={{ color: 'var(--muted)' }}>—</span>);
  }
  return <span style={{ color: 'var(--muted)' }}>—</span>;
}

const card = { background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 16, padding: 14, marginBottom: 12 };

const TABS = [
  { id: 'RIEPILOGO' },
  { id: 'FWA', keys: ['fwa_5g', 'fwa_4g'] },
  { id: 'PACCHETTI', keys: ['fibra_10g', 'fibra_nere', 'fibra_bianche'] },
  { id: 'PROFILI', keys: ['fibra_prof_10g', 'fibra_prof', 'xdsl_30m', 'xdsl_fast200', 'adsl_prof', 'ftto', 'eth_silver', 'eth_gold'] },
];
// Raggruppamento del RIEPILOGO: FTTO/Ethernity in una categoria dedicata (fibra dedicata business).
const RIEP_GRUPPI = [
  { id: 'FWA', keys: ['fwa_5g', 'fwa_4g'] },
  { id: 'PACCHETTI', keys: ['fibra_10g', 'fibra_nere', 'fibra_bianche'] },
  { id: 'PROFILI', keys: ['fibra_prof_10g', 'fibra_prof', 'xdsl_30m', 'xdsl_fast200', 'adsl_prof'] },
  { id: 'DEDICATA', keys: ['ftto', 'eth_silver', 'eth_gold'] },
];

function CoperturaTabs({ colonne }) {
  const [tab, setTab] = useState('RIEPILOGO');
  const t = TABS.find((x) => x.id === tab) || TABS[0];
  const isRiep = tab === 'RIEPILOGO';
  const keys = t.keys || COLS.filter((c) => (colonne?.[c.k] || {}).esito === 'OK').map((c) => c.k);
  const groups = isRiep
    ? RIEP_GRUPPI.map((x) => ({ id: x.id, keys: x.keys.filter((k) => (colonne?.[k] || {}).esito === 'OK') })).filter((g) => g.keys.length)
    : [{ id: t.id, keys }];
  const totale = groups.reduce((n, g) => n + g.keys.length, 0);
  return (
    <div>
      <div style={{ display: 'flex', gap: 5, marginBottom: 8 }}>
        {TABS.map((x) => (
          <button key={x.id} onClick={() => setTab(x.id)} style={{
            flex: 1, padding: '7px 3px', fontSize: 10.5, fontWeight: 700, borderRadius: 9, cursor: 'pointer',
            border: '1px solid ' + (tab === x.id ? 'var(--signal)' : 'var(--line)'),
            background: tab === x.id ? 'var(--surface2)' : 'transparent',
            color: tab === x.id ? 'var(--signal)' : 'var(--muted)',
          }}>{x.id}</button>
        ))}
      </div>
      {totale === 0
        ? <div style={{ color: 'var(--muted)', fontSize: 13 }}>{tab === 'RIEPILOGO' ? 'Nessuna tecnologia vendibile.' : 'Nessun dato.'}</div>
        : groups.map((g, gi) => (
            <div key={g.id}>
              {isRiep && <div style={{ fontSize: 10.5, fontWeight: 800, letterSpacing: '.6px', textTransform: 'uppercase', color: 'var(--signal)', background: 'var(--surface2)', border: '1px solid var(--line)', borderRadius: 8, padding: '5px 9px', margin: gi ? '12px 0 6px' : '0 0 6px' }}>{g.id}</div>}
              {g.keys.map((k) => { const c = COLS.find((x) => x.k === k); return (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid var(--line)' }}>
                  <span style={{ color: 'var(--muted)', fontSize: 13 }}>{c.l}</span>
                  <span style={{ fontSize: 14 }}>{valDisplay(c, colonne?.[k])}</span>
                </div>
              ); })}
            </div>
          ))}
    </div>
  );
}

function riassunto(colonne) {
  const ok = COLS.filter((c) => (colonne?.[c.k]?.esito) === 'OK').map((c) => c.l);
  return ok.length ? ok.join(' · ') : 'Nessuna copertura';
}

function Indirizzo({ ind }) {
  return (
    <div style={{ fontWeight: 700, color: 'var(--ink)', textTransform: 'capitalize' }}>
      {(ind?.comune || '').toLowerCase()} · {(ind?.via || '').toLowerCase()} {ind?.civico}
    </div>
  );
}

export default function CoperturaSsmatePage() {
  const [f, setF] = useState({ provincia: '', comune: '', via: '', civico: '' });
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const [curId, setCurId] = useState(null);
  const [storico, setStorico] = useState([]);
  const [aperti, setAperti] = useState({});
  const poll = useRef(null);

  const topoFetcher = React.useMemo(() => ({
    comuni: (q) => axios.get(`${API}/toponomastica/comuni`, { params: { q } }).then((r) => r.data.items),
    vie: (q, codProv, codCom) => axios.get(`${API}/toponomastica/vie`, { params: { q, codProv, codCom } }).then((r) => r.data.items),
    civici: (cfv) => axios.get(`${API}/toponomastica/civici`, { params: { codForteVia: cfv } }).then((r) => r.data.items),
  }), []);

  const loadStorico = useCallback(() => {
    axios.get(`${API}/ssmate/copertura/storico`).then((r) => setStorico(r.data?.items || [])).catch(() => {});
  }, []);
  useEffect(() => { loadStorico(); return () => clearInterval(poll.current); }, [loadStorico]);

  const verifica = async () => {
    if (!f.provincia.trim() || !f.comune.trim() || !f.via.trim() || !f.civico.trim()) return;
    setBusy(true); setRes(null); setCurId(null);
    try {
      const r = await axios.post(`${API}/ssmate/copertura`, f);
      const id = r.data.id;
      setCurId(id);
      poll.current = setInterval(async () => {
        try {
          const s = await axios.get(`${API}/ssmate/copertura/${id}`);
          if (s.data.stato === 'completato' || s.data.stato === 'errore') {
            clearInterval(poll.current);
            setBusy(false);
            setRes(s.data.stato === 'errore' ? { errore: s.data.errore } : s.data.risultato);
            loadStorico();
          }
        } catch { /* ritenta */ }
      }, 2000);
    } catch (e) {
      setBusy(false);
      setRes({ errore: e.response?.data?.detail || 'Errore avvio verifica' });
    }
  };

  const toggle = (id) => setAperti((a) => ({ ...a, [id]: !a[id] }));
  const items = storico.filter((s) => s.colonne && s.id !== curId);

  return (
    <div style={{ padding: 14 }}>
      <h1 style={{ fontSize: 18, margin: '2px 0 4px', color: 'var(--ink)' }}>Copertura SSMATE</h1>
      <p style={{ margin: '0 0 14px', color: 'var(--muted)', fontSize: 13 }}>Verifica vendibilità per indirizzo.</p>

      <div style={card}>
        <AddressCascade variant="mobile" fetcher={topoFetcher} stepper
          submitLabel={busy ? 'Verifica in corso…' : 'Verifica'} submitDisabled={busy}
          btnClass="m-btn start" onSubmit={verifica}
          onChange={(a) => setF({ ...f, provincia: a.provincia, comune: a.comune, via: a.via, civico: a.civico })} />
      </div>

      {res?.errore && <div style={{ ...card, color: '#ef4444' }}>{res.errore}</div>}
      {res && res.trovato === false && !res.errore && <div style={{ ...card, color: '#f59e0b' }}>Indirizzo non trovato su SSMATE.</div>}
      {res?.colonne && (
        <div style={card}>
          <div style={{ marginBottom: 8 }}><Indirizzo ind={res.indirizzo} /></div>
          <CoperturaTabs colonne={res.colonne} />
        </div>
      )}

      {items.length > 0 && <div style={{ color: 'var(--muted)', fontSize: 12, fontWeight: 700, margin: '6px 2px' }}>STORICO</div>}
      {items.map((s) => (
        <div key={s.id} style={card} onClick={() => toggle(s.id)}>
          <Indirizzo ind={s.indirizzo} />
          {aperti[s.id]
            ? <div style={{ marginTop: 8 }}><CoperturaTabs colonne={s.colonne} /></div>
            : <div style={{ color: 'var(--muted)', fontSize: 12, marginTop: 4 }}>{riassunto(s.colonne)}</div>}
        </div>
      ))}
    </div>
  );
}
